import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "../posthog";

/**
 * Tracks SPA page views in PostHog on every route change.
 */
export function usePostHogPageview() {
  const location = useLocation();

  useEffect(() => {
    // Only capture if PostHog was initialized
    if (!posthog.__loaded) return;

    posthog.capture("$pageview", {
      $current_url: window.location.origin + location.pathname,
    });
  }, [location.pathname]);
}

/**
 * Identifies a user who arrived via /invite/:name.
 *
 * Reads the "ref" from localStorage (set by the InviteRedirect route)
 * and calls posthog.identify() so all their sessions + recordings
 * are tied to that name.
 *
 * Also sets a super property so every future event carries the source.
 */
export function usePostHogIdentify() {
  useEffect(() => {
    if (!posthog.__loaded) return;

    const ref = localStorage.getItem("invite_ref");
    if (!ref) return;

    // identify ties this browser to the person name
    posthog.identify(ref, {
      source: ref,
      arrived_at: localStorage.getItem("invite_arrived_at"),
    });

    // register adds properties to every event this user fires
    posthog.register({ invite_ref: ref });
  }, []);
}
